import styled, { css } from 'styled-components';
var Datalist = styled.datalist.withConfig({
  displayName: "InputRangestyles__Datalist",
  componentId: "sc-1hk702p-0"
})(["display:flex;justify-content:space-between;width:100%;"]);
var trackCSS = css(["width:100%;height:5px;cursor:pointer;border-radius:25px;background:linear-gradient( to right,", ",", " ),", ";background-size:", "%;background-repeat:no-repeat;"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.trackValue;
});
var thumbCSS = css(["width:15px;height:15px;cursor:pointer;background:", ";border-radius:50%;border:solid ", " 1px;margin-top:-6px;box-shadow:0px 1px 3px rgba(0,0,0,0.4);"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.palette['brand-1'];
});
var Input = styled.input.withConfig({
  displayName: "InputRangestyles__Input",
  componentId: "sc-1hk702p-1"
})(["-webkit-appearance:none;width:100%;background:transparent;margin:0;&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&::-ms-track{", "}&::-webkit-slider-thumb{-webkit-appearance:none;", "}&::-moz-range-thumb{", "}&::-ms-thumb{", "}"], trackCSS, trackCSS, trackCSS, thumbCSS, thumbCSS, thumbCSS);
var Label = styled.label.withConfig({
  displayName: "InputRangestyles__Label",
  componentId: "sc-1hk702p-2"
})(["display:inline-block;font-weight:", ";margin-bottom:10px;"], function (props) {
  return props.theme.font.weight.bold;
});
var OptionalLabel = styled.span.withConfig({
  displayName: "InputRangestyles__OptionalLabel",
  componentId: "sc-1hk702p-3"
})(["color:", ";margin-left:8px;font-size:", ";display:inline-block;text-transform:capitalize;"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.font.size.caption;
});
var hiddenStyles = css(["visibility:hidden;width:0;height:0;"]);
var Option = styled.option.withConfig({
  displayName: "InputRangestyles__Option",
  componentId: "sc-1hk702p-4"
})(["padding:0;", ""], function (props) {
  return props.tickMarksLabelsAbove && css(["&:nth-child(even){", "}"], hiddenStyles);
});
Option.displayName = 'option';
var TickMarksLabelsContainer = styled.div.withConfig({
  displayName: "InputRangestyles__TickMarksLabelsContainer",
  componentId: "sc-1hk702p-5"
})(["display:flex;justify-content:space-between;width:100%;"]);
var TickMarkLabel = styled.span.withConfig({
  displayName: "InputRangestyles__TickMarkLabel",
  componentId: "sc-1hk702p-6"
})(["font-size:", ";&:nth-child(odd){", "}"], function (props) {
  return props.theme.font.size.base;
}, hiddenStyles);
export { Input, Datalist, Label, OptionalLabel, Option, TickMarksLabelsContainer, TickMarkLabel };